/* eslint no-underscore-dangle: 0 */
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from './reducers';
import config from '../config/index.json';

const { VITE_NODE_ENV } = import.meta.env;

function saveState(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (e) {
    throw e;
  }
}
function loadState() {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    throw e;
  }
}

function enableReduxTool() {
  /* eslint-disable no-underscore-dangle */
  if ((VITE_NODE_ENV !== 'production' && VITE_NODE_ENV !== 'UAT') && config.enableReduxTool && Boolean(window.__REDUX_DEVTOOLS_EXTENSION__)) {
    return window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
  }
  /* eslint-enable */
}
const persistedState = loadState();
const enableRedux = enableReduxTool();
const store = enableRedux ? createStore(
  reducers,
  persistedState,
  compose(applyMiddleware(thunkMiddleware), enableRedux),
) : createStore(
  reducers,
  persistedState,
  compose(applyMiddleware(thunkMiddleware)),
);

store.subscribe(() => {
  const state = store.getState();
  if (config.saveState) {
    saveState(state);
  }
});

export default store;
